import axios from "axios";
import { END_POINTS } from "../Helper/Constant";

const BASE_URL = import.meta.env.VITE_API_URL;
const API_KEY = import.meta.env.VITE_API_KEY

// Create a reusable axios client
const apiClient = axios.create({
    baseURL: BASE_URL,
    timeout: 15000, // prevents hanging requests
});

/**
 * Generic request wrapper
 * @param {string} endpoint - API endpoint
 * @param {object} data - Request body
 * @param {string} selectedLanguage - Language code
 * @returns {Promise<any>}
 */
const postRequest = async (endpoint, data, selectedLanguage) => {
    try {
        const response = await apiClient.post(endpoint, data, {
            headers: { "Accept-Language": selectedLanguage || "en", "X-API-Key": API_KEY },
        });
        return response?.data;
    } catch (error) {
        // Standardized error handling
        const message = error?.response?.data || error.message || "Request failed";
        throw message;
    }
};

/**
 * Login API
 */
export const login = (email, password, selectedLanguage, fcmToken) =>
    postRequest(END_POINTS.LOGIN, { email, password, fcmToken }, selectedLanguage);

/**
 * Forgot Password API
 */
export const forgotPassword = (email, selectedLanguage) =>
    postRequest(END_POINTS.FORGOT_PASSWORD, { email }, selectedLanguage);
